import { buildBaseURL } from '@warp-drive/utilities';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { EligibilityStatus } from '../data/resources/eligibility-status.type.ts';
import { CONTRACT_HEADER } from '../handlers/type-normalization-handler.ts';

/**
 * Reads the computed eligibility decision for one TAS application from the
 * target v2 contract. The forced reload preserves the endpoint's live decision
 * semantics while still materializing the response through WarpDrive.
 *
 * @param applicationId - Becomes both the nested route segment and resource identity
 * @returns a GET request with `X-Tio-Contract: 2` and cache reload enabled
 */
export function eligibilityStatusFindRecord(applicationId: string) {
  const request = findRecord<EligibilityStatus>('eligibility-status', applicationId);
  const headers = new Headers(request.headers);
  headers.set(CONTRACT_HEADER, '2');

  return {
    ...request,
    url: `${buildBaseURL({ resourcePath: 'api/v2/applications' })}/${encodeURIComponent(applicationId)}/eligibility-status`,
    headers,
    cacheOptions: { reload: true },
  };
}
